import React from "react";
import { ThumbsUp } from "lucide-react";

interface ReactionCounts {
    like?: number;
}

interface NewsOverallReactionProps {
    reactions?: ReactionCounts;
    className?: string;
    showLabels?: boolean;
    size?: "sm" | "md" | "lg";
    hideWhenEmpty?: boolean;
}

const NewsOverallReaction: React.FC<NewsOverallReactionProps> = ({
    reactions = {},
    className = "",
    showLabels = false,
    size = "sm",
    hideWhenEmpty = true,
}) => {
    // Get like count
    const likeCount = reactions.like || 0;

    // Early return if no reactions and hideWhenEmpty is true
    if (likeCount === 0 && hideWhenEmpty) {
        return null;
    }

    // Size configurations
    const sizeConfig = {
        sm: { icon: 16, text: "text-xs", gap: "gap-1" },
        md: { icon: 20, text: "text-sm", gap: "gap-1.5" },
        lg: { icon: 24, text: "text-base", gap: "gap-2" },
    };

    const config = sizeConfig[size];

    // Show empty state if no reactions and hideWhenEmpty is false
    if (sukaCount === 0) {
        return (
            <div
                className={`flex items-center ${config.gap} text-gray-500 dark:text-gray-400 ${className}`}
            >
                <span className={`${config.text} opacity-50`}>
                    {showLabels ? "Belum ada reaksi" : "0"}
                </span>
            </div>
        );
    }

    return (
        <div className={`flex items-center ${config.gap} ${className}`}>
            <ThumbsUp
                size={config.icon}
                className="text-gray-600 dark:text-gray-300"
            />
            <span
                className={`${config.text} text-gray-600 dark:text-gray-300 font-medium`}
            >
                {sukaCount}
            </span>
            {showLabels && (
                <span
                    className={`${config.text} text-gray-500 dark:text-gray-400 ml-1`}
                >
                    Suka
                </span>
            )}
        </div>
    );
};

export default NewsOverallReaction;
